import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router";
import { ErrorBoundary } from "./routes/components";
import { routesSection } from "./routes/sections";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { CONFIG } from "src/global-config";

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorBoundary />,
    children: routesSection,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      {/* Global fallback title */}
      <Helmet>
        <title>{CONFIG.appName}</title>
      </Helmet>

      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>
);

// Register the Firebase messaging service worker
if ("serviceWorker" in navigator) {
  // Register the service worker
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log(
        "Firebase Messaging Service Worker registered with scope:",
        registration.scope
      );
    })
    .catch((error) => {
      console.log(
        "Firebase Messaging Service Worker registration failed:",
        error
      );
    });

  // Listen for messages from the service worker
  navigator.serviceWorker.addEventListener("message", (event) => {
    const { action, key, value } = event.data;

    if (action === "set") {
      localStorage.setItem(key, value);
      console.log(`Set ${key} in localStorage`);
    }

    if (action === "navigate" && value) {
      window.location.href = value;
      console.log(`Navigating to: ${value}`);
    }
  });
}

reportWebVitals();
